<template>
  <div class="copyright-two">
    <div
      class="copyright-container"
      :style="{
        'background-color': configDataForm.backgroundColor,
        color: configDataForm.fontColor,
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <span v-for="item in configDataForm.items" :key="item">
        <span v-if="item.type == 1">
          <a :href="item.linkUrl ? item.linkUrl : '#'" target="_blank">
            {{ item.text }}
          </a>
        </span>
        <img v-else :src="item.iconFullUrl || noUpload" fit="cover" />
      </span>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <copyright-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></copyright-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import copyrightEditForm from './CopyrightEditForm.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props-configDataForm:', props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
 query: '?url',
});
// 直接获取目标图片 URL
const noUpload = images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref({
  items: [
    {
      sortNum: 1,
      type: 1,
      text: '版权所有：成都某某莫某科技有限公司',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon1',
      iconNameObj: null,
    },
    {
      sortNum: 3,
      type: 1,
      text: '©2015',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon3',
      iconNameObj: null,
    },
    {
      sortNum: 4,
      type: 1,
      text: '蜀ICP备19xxxx60号',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon4',
      iconNameObj: null,
    },
    {
      sortNum: 2,
      type: 2,
      text: '',
      linkUrl: '',
      iconName: '/src/views/components/website/footer/image/beian.png',
      iconFileKey: 'icon2',
      iconNameObj: null,
    },
    {
      sortNum: 5,
      type: 1,
      text: '川公网安备 5101xxxxxx1419号',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon5',
      iconNameObj: null,
    },
  ],
  backgroundColor: '#000000',
  fontColor: '#ffffff',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
}
// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
// 操作显不显示编辑内容按钮
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

.copyright-two {
  width: 100%;
}

/* PC端样式 */
@include pc {
  .copyright-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 138px;

    span {
      display: inline;
      margin: 4px;
      font-size: 16px;
      color: #fff;

      img {
        width: 18px;
        height: 18px;
      }
    }

    a {
      transition: color $website-duration-fast $website-ease-out;

      &:hover {
        color: $website-primary-light;
      }
    }
  }
}

/* 移动端样式 */
@include mobile {
  .copyright-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: auto;
    padding: 4vw;

    span {
      display: inline;
      margin: 1vw 2vw;
      font-size: 3vw;
      color: #fff;

      img {
        width: 4vw;
        height: 4vw;
      }
    }

    a {
      transition: color $website-duration-fast $website-ease-out;

      &:active {
        color: $website-primary-light;
      }
    }
  }
}

.link {
  cursor: pointer;
}
</style>
